/**
 * Most endpoints answer HTTP 200 with `status` set to "success" or "fail".
 * Use this in a mutationFn so anything but "success" reaches onError instead of
 * being treated as a successful response.
 */
export const requireSuccess = <T extends { status?: string; message?: string }>(res: T): T => {
    if (res?.status !== 'success') {
        throw new Error(res?.message ?? `request failed with status "${res?.status}"`);
    }
    return res;
};
